module.exports = __webpack_public_path__ + "4eb8dc65d0d5581d74acc23ab96c0d65.png";


//////////////////
// WEBPACK FOOTER
// ./program/frontend/welcome/avatar.png
// module id = 975
// module chunks = 0